import React from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import withEndpointAuthorization from '../../../units/authorization/withEndPointAuthorization';

import { PUT } from '../../../../config/permissions';

import { generateApproveManualVoucherPaymentEndpoint } from '../../../../config/endpoints';
import { approveManualVoucherPayment } from '../../../../actions/corporate/ManualVoucherPayment';

const ApproveManualVoucherPaymentCell = ({
  id,
  tableFilters,
  dispatchApproveManualVoucherPayment,
  loading,
}) => {
  const onApprove = () => {
    if (loading) return;

    dispatchApproveManualVoucherPayment({
      manualVoucherPaymentId: id,
      tableFilters,
    });
  };

  return (
    <i
      tabIndex="0"
      role="button"
      className="fa fa-check-circle text-success"
      onKeyPress={onApprove}
      onClick={onApprove}
    />
  );
};

ApproveManualVoucherPaymentCell.propTypes = {
  id: PropTypes.number.isRequired,
  tableFilters: PropTypes.shape({}),
  dispatchApproveManualVoucherPayment: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

ApproveManualVoucherPaymentCell.defaultProps = {
  tableFilters: {},
};

const mapStateToProps = ({ CorporateUnit }) => ({
  loading: !CorporateUnit.ManualVoucherPayment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchApproveManualVoucherPayment: approveManualVoucherPayment,
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApproveManualVoucherPaymentCell);

export default withEndpointAuthorization({
  url: generateApproveManualVoucherPaymentEndpoint(),
  mapUrlParamsToProps: { id: 'id' },
  permissionType: PUT,
})(connectedComponent);
